import type {
    ComposableOptionsBase,
    MembershipChoice,
    MembershipChoiceTypeCount
} from '~/types';

export interface UseAccountUtilsOptions extends ComposableOptionsBase {}
export function useAccountUtils(options: Partial<UseAccountUtilsOptions> = {}) {
    const accountSectionPath = '/account';
    const route = useRoute();

    function isInAccountSection(): boolean {
        return Boolean(route.matched.find((match) => match.path === accountSectionPath));
    }

    function getMembershipChoiceTypeCounts(memberships: MembershipChoice[]): MembershipChoiceTypeCount {
        const value: MembershipChoiceTypeCount = {
            personal: 0,
            entity: 0
        }

        memberships.forEach((mObj) => {
            if (mObj.context in value) ++value[mObj.context];
        });

        return value;
    }

    return {
        accountSectionPath,
        isInAccountSection,
        getMembershipChoiceTypeCounts
    };
}
